import PropTypes from "prop-types";
import _ from "lodash";
import { Box, Divider } from "@mui/material";
import useFetch from "../../utils/useFetch";
import FormControl from "../FormControl";
import FormControlWithSubFields from "../FormControlWithSubFields";
import "../../styles/QuestionnaireContent.css";
import { useState, useEffect } from "react";
import LoadingSpinner from "../../toolkit/LoadingSpinner";
import ErrorAlert from "../../toolkit/ErrorAlert";
import BaseURL from "../../utils/base-uri.json";
import { SettingsBackupRestore } from "@mui/icons-material";
import * as math from "mathjs";

function getInputType(type) {
  switch (type) {
    case "CtrlRadio":
      return "radio";
    case "CtrlCheckBox":
      return "checkbox";
    case "CtrlSelect":
    case "CtrlSelectMultiple":
      return "select";
    case "CtrlTextArea":
      return "textarea";
    case "CtrlTextNumber":
      return "text"; //TODO: Need to changes this from text to number and need to fix the binding issue.
    case "CtrlTextEmail":
      return "email";
    case "CtrlTextMobile":
      return "tel";
    case "CtrlTextPassword":
      return "password";
    case "CtrlTextDate":
      return "date";
    case "CtrlLabel":
      return "label";
    case "CtrlText":
      return "text";
    case "CtrlButton":
      return "button";
    default:
      return "none";
  }
}
// const params = new URLSearchParams(window.location.search);
// const PQID = params.get("pqid");

function getFieldOptions(str = "") {
  if (!str) {
    str = "";
  }
  {
    return str
      .split("|")
      .filter((i) => i.trim())
      .map((i) => ({ id: i, text: i }));
  }
}

function getDefaultUserResponse(field) {
  return ["CtrlSelectMultiple"].includes(field.type)
    ? field.answer.split("|")
    : field.answer;
}

function getFiledPositioning(alignment) {
  return `${alignment}` === "0" ? "horizontal" : "vertical";
}

function fieldsAdaptor({ subSectionQuestions = [] }) {
  const userResponse = {};
  const userResponseDependencies = {};
  subSectionQuestions = subSectionQuestions.map((field) => {
    const newField = {
      id: `${field.questionId}`,
      text: field.questionText,
      required: field.isMandatory,
      heighlight: field.hasHighlights + "",
      color: field.questionColor,
      inputType: getInputType(field.inputType),
    };
    const subFields = field.questionColumns || [];
    if (subFields.length === 1) {
      const sf = subFields[0];
      Object.assign(newField, {
        name: `${sf.columnId}`,
        inputType: getInputType(sf.type),
        multiple: sf.type === "CtrlSelectMultiple",
        options: getFieldOptions(sf.options),
        userResponse: getDefaultUserResponse(sf),
        fieldPositioning: getFiledPositioning(sf.alignment),
        preQualRecId: sf.preQualRecId,

        Reference: sf.qTableReference,
        TableRefFieldValueDisplay:
          sf.qTableReference?.qcTableRefFieldValueDisplay,
        TableReference: sf.qTableReference?.qcTableReference,
        TableReferenceField: sf.qTableReference?.qcTableReferenceField,
        ButtonTypeReferenceValue: sf.buttonTypeReferenceValue,
      });

      // if (field.ParentQColumnId) {
      //   Object.assign(newField, {
      //     dependentOn: field.ParentQColumnId,
      //     enableIfParentValue: field.questionValue || true,
      //   });
      // }
    } else if (subFields.length > 1) {
      newField.subFields = subFields.map((sf) => {
        return {
          id: sf?.columnId,
          name: sf?.columnId,
          inputType: getInputType(sf?.type),
          multiple: sf?.type === "CtrlSelectMultiple",
          options: getFieldOptions(sf?.ColumnOptions),
          userResponse: getDefaultUserResponse(sf),
        };
      });
      newField.fieldPositioning = getFiledPositioning(subFields[0].alignment);
    }

    if (field?.dependOn && field?.dependOn.length > 0) {
   

      var parent = field.dependOn[0];

      Object.assign(newField, {
        dependentOn: parent.questionId,
        dependentValue: parent.questionValue,
        enableIfParentValue: parent.enableIfParentValue || true,
      });
    }

    return newField;
  });
  subSectionQuestions.forEach((field, idx, fields) => {
    if (field.subFields) {
      field.subFields.forEach((sf) => {
        _.set(userResponse, [field.id, sf.id], sf.userResponse || "");
      });
    } else {
      _.set(userResponse, [field.id], field.userResponse || "");
    }
    if (field.dependentOn) {
      const parent = fields.find((f) => f.id == field.dependentOn);

      if (parent) {
        field.hidden = parent.userResponse !== field.dependentValue;
        _.set(userResponseDependencies, [field.id], {
          parent: parent.id,
          enableIfParentValue: field.enableIfParentValue,
        });
      }
    }
  });
  return { subSectionQuestions, userResponse, userResponseDependencies };
}

function formDataAdaptor(oldData, userResponse) {
  const data = _.cloneDeep(oldData);
  for (let idx = 0; idx < userResponse.length; idx++) {
    Object.keys(userResponse[idx]).forEach((fieldId) => {
      const newFieldData = userResponse[idx][fieldId];
      if (newFieldData === undefined) return;
      const oldFieldData = data?.data?.subSectionDetails[
        idx
      ]?.subSectionQuestions.find((f) => `${f.questionId}` === `${fieldId}`); //TODO : Add data.subSectionQuestions replace with fields
      if (!oldFieldData) return;
      const oldSubFields = oldFieldData.questionColumns || [];
      if (oldSubFields.length === 1) {
        oldSubFields[0].answer = _.isArray(newFieldData)
          ? newFieldData.join("|")
          : newFieldData;
      } else if (oldSubFields.length > 1) {
        oldSubFields.forEach((sf) => {
          if (sf.columnId in newFieldData)
            sf.answer = newFieldData[sf.columnId];
        });
      }
    });
  }

  return data;
}

export default function ChecklistQuestionnaireContext({
  dataUrl,
  setShowFormButtons,
  setModifiedData,
  reset,
  resetButtons,
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  hasUnsavedChanges,
  IsSubSectionCompleted,

  Validate,
  Required,
  SubSectionName,
  Triger,
  VIEWMODE,
  RESETQUESTIONS,
  subSections,
}) {
  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");

  //   const {
  //     data: resp,
  //     loading,
  //     error,
  //   } = useFetch(BaseURL.baseUrl + "Prequalification/SectionOrSubSectionDetails?pqId=" + PQID + "&sectionId=" + Secid + "&subSectionTypeCondition=" + SubSectionTypeCondition + "&sectionType=" + SectionType + "&subSectionId=" + SubId,); // TODO: remove localhost arg

  const [resp, setResp] = useState(null);
  const [userResponse, setUserResponse] = useState([]);
  const [userResponseDependencies, setUserResponseDependencies] = useState([]);
  const [subSectionQuestions, setFields] = useState([]);
  const [subSectionResp, setSubSectionResp] = useState();
  const [unhiddenFields, setUnhiddenFields] = useState(
    //subSectionQuestions.filter((f) => !f.hidden)
    []
  );
  useEffect(() => {
    if (resp?.data?.subSectionDetails) {
      setSubSectionResp(resp?.data);

      var userResponseList = [];
      var userResponseDependenciesList = [];
      var subSectionQuestionsList = [];
      for (let i = 0; i < resp?.data?.subSectionDetails.length; i++) {
        if (resp?.data?.subSectionDetails[i].subSectionQuestions) {
          const {
            subSectionQuestions,
            userResponse,
            userResponseDependencies,
          } = fieldsAdaptor(resp?.data?.subSectionDetails[i]);
          userResponseList.push(userResponse);
          subSectionQuestionsList.push(subSectionQuestions);
          userResponseDependenciesList.push(userResponseDependencies);
        }
      }
      setUnhiddenFields([]);
      setUserResponse(userResponseList);
      setUserResponseDependencies(userResponseDependenciesList);
      setFields(subSectionQuestionsList);
    }
  }, [resp]);
  useEffect(() => {
    const subSection = subSections.find((x) => x.checklistSubSectionId == SubId);
    if (subSection) {
      // Transform the original data using .map
      const transformedData = {
        data: {
          editAccess: false,
          subSectionDetails: [
            {
              subSectionName: subSection.subSectionName,
              subSectionid: subSection.subSectionid,
              subSectionTypeCondition: subSection.subSectionTypeCondition,
              editAccess: subSection.editAccess,
              subSectionQuestions: subSection.checklistQuestions?.map(
                (question) => {
                  return {
                    questionId: question.checklistQuestionId,
                    questionText: question.checklistQuestionText,
                    isMandatory: question.isMandatory,
                    isBold: question.isBold,
                    hasHighlights: question.hasHighlights,
                    questionColumns: question.questionColumns?.map((column) => {
                      return {
                        columnId: column.columnId,
                        type: column.type,
                        answer: column.answer,
                      };
                    }),
                  };
                }
              ),
            },
          ],
          subSectionTypeCondition: "",
          interimSubSectionExists: false,
          restrictedSectionEdit: false,
          isEdit: false,
        },
      };


      setResp(transformedData);
    } else {
      setSubSectionResp([]);
      setResp(null);
      var userResponseList = [];
      var userResponseDependenciesList = [];
      var subSectionQuestionsList = [];
      
      setUnhiddenFields([]);
      setUserResponse([]);
      setUserResponseDependencies(userResponseDependenciesList);
      setFields(subSectionQuestionsList);
    }
  }, [SubId, subSections]);
  //   }, [resp]);

  useEffect(() => {
    if (subSectionQuestions) {
      var unhiddenFieldsList = [];
      for (let i = 0; i < subSectionQuestions.length; i++) {
        unhiddenFieldsList.push(
          subSectionQuestions[i].filter((f) => !f.hidden)
        );
        setShowFormButtons(
          !!subSectionQuestions[i].filter((f) => f.inputType !== "label").length
        ); //todo: Revisit again
      }
      setUnhiddenFields(unhiddenFieldsList);
    }
  }, [subSectionQuestions]);

  useEffect(() => {
    if (reset) {
      var userResponseList = [];
      var subSectionQuestionsList = [];
      var userResponseDependenciesList = [];
      // var userResponseList = resp?.data?.subSectionDetails.map((r) => {
      //return fieldsAdaptor(r)
      for (let i = 0; i < resp?.data?.subSectionDetails.length; i++) {
        if (resp?.data?.subSectionDetails[i].subSectionQuestions) {
          const {
            subSectionQuestions,
            userResponse,
            userResponseDependencies,
          } = fieldsAdaptor(resp?.data?.subSectionDetails[i]);

          userResponseList.push(userResponse);
          subSectionQuestionsList.push(subSectionQuestions);
          userResponseDependenciesList.push(userResponseDependencies);
        }
      }
      // })
      setUserResponse(userResponseList);
      setUserResponseDependencies(userResponseDependenciesList);
      setFields(subSectionQuestionsList);
      setModifiedData({});
    }
  }, [reset]);

  useEffect(() => {
    setModifiedData({}); //TODO:- Add new code  here!
  }, [resetButtons]);

  function onResponseChange(fieldId, value, qColumnId) {
    const data = _.cloneDeep(userResponse);

    for (let idx = 0; idx < subSectionQuestions.length; idx++) {
  
      //Dependency Questions handling
      for (const [key, value1] of Object.entries(userResponseDependencies[0])) {

        if (value1.parent !== fieldId)
          //If the question is not dependent on any question
          continue;

        const dependentField = subSectionQuestions[idx].find(
          (f) => f.id == key
        ); //get questions info based on key
        if (dependentField) {
          dependentField.hidden = value != dependentField?.dependentValue;
          setFields([...subSectionQuestions]);
        }
      }

      if (Array.isArray(data[idx][fieldId])) {
        data[idx][fieldId][qColumnId] = value[qColumnId];
        //data[idx][fieldId][qColumnId] = value=="true"?true:false;
      } else {
        data[idx][fieldId] = value;
      }
    }

    setUserResponse(data);
    setModifiedData(formDataAdaptor(resp, data));
  }

  const setValidate = (r) => {
    Validate(r);
  };

  return (
    <>
      {
        <Box className="questionnaire-content border-0 overflow-auto">
          <form style={{ height: "240px" }}>
            {unhiddenFields?.map((fields, idx) => (
              <div key={idx}>
                <b
                  hidden={
                    SubSectionName ==
                    subSectionResp?.subSectionDetails[idx]?.subSectionName
                  }
                >
                  {subSectionResp?.subSectionDetails[idx]?.subSectionName}
                </b>
                {fields?.map((field, idx1) => (
                  <Box key={field?.id}>
                    {field?.subFields ? (
                      <FormControlWithSubFields
                        {...field}
                        userResponse={userResponse}
                        onResponseChange={onResponseChange}
                        IDX={idx}
                        SubSectionResp={subSectionResp}
                        VIEWMODE={VIEWMODE}
                      />
                    ) : (
                      <div>
                        <FormControl
                          fieldId={field?.id}
                          required={field?.required}
                          label={field?.text}
                          inputType={
                            subSectionResp?.subSectionDetails[idx]
                              ?.editAccess == false || VIEWMODE
                              ? field?.inputType
                              : "label"
                          }
                          multiple={field?.multiple}
                          items={field?.options}
                          value={userResponse[idx][field?.id] || ""}
                          //checked={userResponse[idx][field?.id] == 'true'}
                          checked={userResponse[idx][field?.id] == "true"}
                          handleChange={(value) =>
                            onResponseChange(field?.id, value, idx)
                          }
                          labelPositioning={
                            field?.labelPositioning || "horizontal"
                          }
                          fieldPositioning={
                            field?.fieldPositioning || "vertical"
                          }
                          width={90}
                          disabled={field?.disabled ?? false}
                          color={field?.color}
                          heighlight={field?.heighlight}
                          Reference={field?.Reference}
                          //setValidate={(val)=>setValidate(field?.id, val, idx)}
                          setValidate={setValidate}
                          // setRequired={setRequired}
                          TableRefFieldValueDisplay={
                            field?.TableRefFieldValueDisplay
                          }
                          TableReference={field?.TableReference}
                          TableReferenceField={field?.TableReferenceField}
                          hasUnsavedChanges={hasUnsavedChanges}
                          buttonTypeReferenceValue={
                            field?.ButtonTypeReferenceValue
                          }
                          Pqid={PQID}
                          Triger={Triger}
                          reset={reset}
                        />
                      </div>
                    )}
                    {idx < unhiddenFields.length - 1 && <Divider />}
                  </Box>
                ))}
              </div>
            ))}
          </form>
        </Box>
      }
    </>
  );
}

ChecklistQuestionnaireContext.propTypes = {};

ChecklistQuestionnaireContext.defaultProps = {
  onResponseChange: () => {},
};
